import FollowUpMessages from './FollowUpMessages'

export default FollowUpMessages
